module.exports = __webpack_public_path__ + "img/copy-link-copy-link.6c7d18d9.svg";